import $ from 'jquery';
import 'jquery-mask-plugin';
window.jQuery = window.$ = $;
